export default '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="7 5 12 14"><path fill="currentColor" d="M19 12 7 19V5z"></path></svg>';